import { useOuraData } from "../contexts/OuraDataContext";

/**
 * WHAT:
 *   Optimized Stress Hook using centralized data context.
 *
 * WHY:
 *   Uses centralized data context instead of making separate API calls.
 *
 * @returns Object containing stress data, error, loading state, and stress metrics
 *
 */
export const useOptimizedStress = () => {
  const { error, loading, stress } = useOuraData();

  return {
    averageStress: stress?.average_stress ?? 0,
    error,
    loading,
    recovery: stress?.recovery ?? 0,
    recoveryHigh: stress?.recovery_high ?? 0,
    stress,
    stressHigh: stress?.stress_high ?? 0,
    stressResistance: stress?.stress_resistance ?? 0,
  };
};
